import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  HTTP_FAILURE: 'HTTP_FAILURE',
  HTTP_REQUEST: 'HTTP_REQUEST',
  HTTP_SUCCESS: 'HTTP_SUCCESS',
};

export const actionCreators = {
  request: (request: any) => ({
    type: actionTypes.HTTP_REQUEST,
    payload: { request },
    [WAIT_FOR_ACTION]: actionTypes.HTTP_SUCCESS,
    [ERROR_ACTION]: actionTypes.HTTP_FAILURE,
  }),
  success: (response: any) => ({
    type: actionTypes.HTTP_SUCCESS,
    payload: { response },
  }),
  failure: (error: Error) => ({
    type: actionTypes.HTTP_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
